module.exports = 1;



// WEBPACK FOOTER //
// ./lib/values/expires-never.js